export const gatewayServiceQueryKeys = {
    all: ["gatewayService"] as const,
    registryInfo: (gatewayId: string) =>
        [...gatewayServiceQueryKeys.all, "registryInfo", gatewayId] as const,
    registryConfig: (gatewayId: string) =>
        [...gatewayServiceQueryKeys.all, "registryConfig", gatewayId] as const,
    gwReading: (org: { organization_id: string; }) =>
        [...gatewayServiceQueryKeys.all, "gwReading", org] as const,
    gwAndLDSUStatus: (gatewayId: string, query: { time_range?: string; offset?: string; } = {}) =>
        [...gatewayServiceQueryKeys.all, "gwAndLDSUStatus", gatewayId, query] as const,
};
